import { dsLogger } from '../../shared/services/logger/logger.instance';

export const dialogLogger = dsLogger.extend('dialog');
